module.exports = __webpack_public_path__ + "static/exchange-platform-0f04d239310bc1a3cdcb29f0384c8d77.svg";